import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Minibusonrentformatheranpune() {



const cardData =
{
  keyword: 'Mini Bus on Rent for Matheran Pune',
  heading: 'Sanavi Travels: Mini Bus on Rent for Matheran Pune',
  headingDescription: 'Sanavi Travels offers dependable mini bus on rent for Matheran Pune, ideal for families, friends, corporate groups, school outings, and picnic travelers planning a smooth and organized hill-station journey. Our mini bus rental service ensures comfortable group travel up to Matheran entry points with professional drivers, well-maintained vehicles, and flexible travel plans.',

  top: 'Top Travel Experiences & Attractions While Visiting Matheran',

  topPlaces: [
    {
      title: 'Matheran Hill Station Experience',
      description: 'Matheran is one of Maharashtra’s most popular eco-friendly hill stations, known for its vehicle-free environment, lush greenery, and peaceful climate. Hiring a mini bus for Matheran from Pune allows groups to travel together comfortably up to Dasturi Naka or other permitted drop points. The journey through winding ghats becomes enjoyable as everyone shares the experience without worrying about multiple vehicles, coordination issues, or parking challenges. Families, corporate teams, and picnic groups benefit from organized arrival and reduced travel fatigue.'
    },
    {
      title: 'Panorama Point & Sunrise Views',
      description: 'Panorama Point is famous for its breathtaking sunrise and wide valley views. Group travelers using a mini bus can plan early departures efficiently, ensuring everyone reaches on time without confusion. Shared transport helps manage schedules better and keeps the group together for memorable sightseeing moments.'
    },
    {
      title: 'Echo Point & Louisa Point',
      description: 'Echo Point and Louisa Point are popular attractions offering scenic landscapes and fun group interactions. Mini bus travel makes it easy for groups to move between viewpoints smoothly before entering the vehicle-restricted zone, ensuring a relaxed sightseeing experience.'
    },
    {
      title: 'Family Picnic & Leisure Time',
      description: 'Matheran is ideal for calm family picnics away from city noise. A mini bus provides a safe, comfortable environment for elders and children during the journey, allowing families to focus on relaxation rather than travel logistics.'
    },
    {
      title: 'Corporate Team Outings',
      description: 'Corporate teams often choose Matheran for stress-free retreats and bonding activities. Mini bus rental supports punctual group travel, encourages team interaction during the journey, and ensures professional, disciplined transport arrangements.'
    },
    {
      title: 'Friends Group Weekend Trips',
      description: 'Friends planning weekend getaways to Matheran prefer mini buses for affordability and convenience. Traveling together enhances enjoyment, enables shared conversations, and makes the journey part of the overall trip experience.'
    },
    {
      title: 'School & Educational Trips',
      description: 'Educational institutions organize trips to Matheran for nature studies and student outings. Mini bus rentals allow teachers to supervise students easily, maintain discipline, and ensure safe group movement throughout the journey.'
    },
    {
      title: 'Wedding & Family Function Travel',
      description: 'For destination weddings or family functions near Matheran, mini buses are ideal for guest transport. They simplify logistics, ensure timely arrivals, and reduce transportation stress during special occasions.'
    },
    {
      title: 'Overnight & Multi-Day Hill Trips',
      description: 'Many Matheran trips involve overnight stays. Mini buses designed for outstation travel offer comfortable seating, adequate luggage space, and reliable performance for extended journeys.'
    },
    {
      title: 'Custom Maharashtra Hill Tour Plans',
      description: 'Mini bus rentals allow flexible itineraries, enabling groups to combine Matheran with nearby destinations such as Karjat or Lonavala, creating personalized hill-tour experiences.'
    }
  ],

  services: [
    {
      name: 'Mini Bus on Rent for Matheran Pune',
      description: 'Sanavi Travels provides specialized mini bus rental services for Matheran Pune, designed for safe, comfortable, and well-coordinated group travel. Our fleet includes 12, 16, and 20 seater mini buses suitable for families, corporate teams, schools, and tourist groups. Spacious seating, smooth suspension, professional drivers, and transparent pricing ensure a stress-free hill journey from Pune to Matheran entry points.'
    },
    {
      name: 'AC Mini Bus Matheran',
      description: 'AC mini buses offer enhanced comfort during the journey, keeping passengers relaxed and refreshed, especially during warm travel days.'
    },
    {
      name: 'Non AC Mini Bus Matheran',
      description: 'Non-AC mini buses provide an economical travel option for groups seeking affordability without compromising safety or seating comfort.'
    },
    {
      name: '12 Seater Mini Bus Matheran',
      description: '12 seater mini buses are ideal for small families or close-knit groups planning a comfortable Matheran trip.'
    },
    {
      name: '16 Seater Mini Bus Matheran',
      description: '16 seater mini buses suit medium-sized groups, balancing capacity, comfort, and budget for hill station travel.'
    },
    {
      name: '20 Seater Mini Bus Matheran',
      description: '20 seater mini buses are perfect for large groups, corporate teams, and school outings traveling together.'
    },
    {
      name: 'Luxury Mini Bus Matheran',
      description: 'Luxury mini buses feature premium interiors and upgraded seating, suitable for VIP guests and special group occasions.'
    },
    {
      name: 'Mini Bus for Family Matheran',
      description: 'Family-focused services ensure safe, calm, and convenient travel for all age groups during the Matheran journey.'
    },
    {
      name: 'Mini Bus for Corporate Matheran',
      description: 'Corporate mini bus services support professional, punctual transport for team outings, meetings, and retreats.'
    },
    {
      name: 'Mini Bus for Group Matheran',
      description: 'Group travel mini bus services keep everyone together, simplifying coordination and enhancing the overall travel experience.'
    },
    {
      name: 'Affordable Mini Bus Rental Matheran',
      description: 'Affordable pricing plans help groups manage budgets effectively while enjoying reliable and comfortable transportation.'
    },
    {
      name: 'Best Mini Bus Service Matheran',
      description: 'Sanavi Travels is trusted for consistent service quality, punctuality, and customer satisfaction for Matheran routes.'
    },
    {
      name: 'Mini Bus with Driver Matheran',
      description: 'All mini buses come with trained drivers familiar with ghat roads and Matheran travel restrictions, ensuring safe and smooth journeys.'
    },
    {
      name: 'Mini Bus for Wedding Matheran',
      description: 'Wedding travel services help manage guest transport efficiently for destination weddings and related functions.'
    },
    {
      name: 'Mini Bus for Picnic Matheran',
      description: 'Picnic-focused mini bus services provide relaxed, coordinated travel for leisure and recreational group outings.'
    }
  ],

  tableData: [
    ['Mini Bus', 'Matheran Trip'],
    ['AC', 'Non AC'],
    ['Family', 'Corporate'],
    ['School Trip', 'Group Picnic'],
    ['Affordable', 'Luxury Options']
  ],

  whychoose: [
    {
      WhyChooseheading: 'Experienced Ghat Route Drivers',
      WhyChoosedescription: 'Our drivers are experienced with hilly and ghat routes leading to Matheran, ensuring safe driving, smooth navigation, and punctual arrivals.'
    },
    {
      WhyChooseheading: 'Comfortable & Well-Maintained Mini Buses',
      WhyChoosedescription: 'All mini buses are regularly serviced, cleaned, and maintained to provide comfortable seating and reliable performance.'
    },
    {
      WhyChooseheading: 'Multiple Seating Options',
      WhyChoosedescription: 'We offer 12, 16, and 20 seater mini buses, allowing groups to select the right vehicle size.'
    },
    {
      WhyChooseheading: 'Transparent Pricing',
      WhyChoosedescription: 'Clear pricing with no hidden charges helps groups plan trips confidently and within budget.'
    },
    {
      WhyChooseheading: 'Flexible Pickup & Scheduling',
      WhyChoosedescription: 'Custom pickup points and flexible timings ensure convenience for all travelers.'
    },
    {
      WhyChooseheading: 'Safe & Sanitized Vehicles',
      WhyChoosedescription: 'Vehicles are sanitized and checked before every trip to maintain hygiene and passenger safety.'
    },
    {
      WhyChooseheading: 'Reliable Outstation Partner',
      WhyChoosedescription: 'Sanavi Travels is known for dependable outstation travel services and consistent customer satisfaction.'
    },
    {
      WhyChooseheading: 'End-to-End Travel Support',
      WhyChoosedescription: 'From booking to drop-off, our support team assists with coordination and journey management.'
    }
  ]
};

const faqData = [
  {
    question: 'Do you provide mini bus rental from Pune to Matheran?',
    answer: 'Yes, Sanavi Travels offers mini bus rental services from Pune to Matheran entry points with AC and Non-AC options.'
  },
  {
    question: 'Is mini bus suitable for family trips?',
    answer: 'Yes, mini buses are ideal for family travel, offering comfort, safety, and group convenience.'
  },
  {
    question: 'Are AC mini buses available?',
    answer: 'Yes, AC mini buses are available and recommended for comfortable travel.'
  },
  {
    question: 'Can corporate groups book mini buses for Matheran?',
    answer: 'Yes, corporate teams frequently book mini buses for outings, retreats, and leisure trips.'
  },
  {
    question: 'Are drivers experienced with ghat roads?',
    answer: 'Yes, our drivers are trained and experienced with ghat and hill routes.'
  },
  {
    question: 'Is this service suitable for school trips?',
    answer: 'Yes, mini buses are commonly used for school and educational trips.'
  },
  {
    question: 'Can pickup locations be customized?',
    answer: 'Yes, pickup points and schedules can be customized as per group needs.'
  },
  {
    question: 'Is pricing transparent?',
    answer: 'Yes, we follow transparent pricing with no hidden charges.'
  },
  {
    question: 'Is advance booking required?',
    answer: 'Advance booking is recommended during weekends and peak seasons.'
  },
  {
    question: 'Do you provide drivers with the mini bus?',
    answer: 'Yes, all mini buses are provided with professional drivers.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rahul Deshmukh',
    feedback: 'We hired a mini bus from Sanavi Travels for our family trip to Matheran. The vehicle was clean, comfortable, and perfect for group travel. The driver handled the ghat roads confidently and ensured a smooth journey. Everyone enjoyed traveling together, making the trip memorable.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Pooja Kulkarni',
    feedback: 'Our office team booked a mini bus for a Matheran outing with Sanavi Travels. The service was punctual, well-organized, and stress-free. The bus was spacious, and the driver was polite and professional. Highly recommended for group travel.',
    rating: 5
  }
];































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];





const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mini Bus on Rent for Matheran Pune - Sanavi Travels",
  "description": "Sanavi Travels offers mini buses on rent for Matheran trips from Pune, including AC and Non-AC options in 12-seater, 16-seater, and 20-seater configurations. Luxury mini buses are also available for family trips, corporate travel, group tours, weddings, and picnics with professional drivers at affordable rates.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "10000+"
  }
};











  return (
    <div>

<Helmet>
  <title>
    Call : +91 7387507373 | Mini Bus on Rent for Matheran Pune | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book mini buses for Matheran trips from Pune with Sanavi Travels. AC & Non-AC 12, 16, and 20-seater luxury mini buses for family trips, corporate travel, group tours, weddings, and picnics with driver at best prices."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/299.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Minibusonrentformatheranpune;